/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";

// Dashboard example components

import DataTable from "examples/Tables/DataTable";

// Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDCard from "components/MDCard";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";

import Alert from "@mui/material/Alert";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";

// @mui material icons
import CloseIcon from "@mui/icons-material/Close";

// Some required packages for generate and print qr
import { Document, Page, StyleSheet, View } from "@react-pdf/renderer";
import QRCode from "react-qr-code";

import { useReactToPrint } from "react-to-print";

// Utils
import TextError from "utils/TextError";

import { CSVLink } from "react-csv";

// Notification
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import MDSnackbar from "components/MDSnackbar";
import DatePicker from "react-datepicker";

// Formik and Yup
import { useFormik } from "formik";
import * as Yup from "yup";

// Functions from store
import {
  calculatePacketDetails,
  calculatePacketWeight,
  createAsn,
  createDynamicColumn,
  getAsnDetails,
  getBinsForPrint,
  getDailyDemand,
  getDailyDemandForDownload,
  getDeliveryPlant,
  getDynamicColumn,
  getPackageType,
  getPartNo,
  getPartNoForPlanner,
  getPlant,
  getPurchaseOrdersForDemand,
  getSubModulesByRoleId,
  getUnConfirmedMonthlyDemand,
  getUnloadingPoint,
  getVendorsListForPlanner,
  updateActualQty,
  uploadCsvForDailyDemand,
} from "../../../store";

// React-Select component and styling
import Select from "react-select";
import Config from "../../../config/index";
import "../../../index.css";

// Cookies
import DownloadDataButton from "components/standardized-components/DownloadDataButton";
import Cookies from "universal-cookie";

const cookies = new Cookies();

let desLength = Config.descriptionLength;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  color: "black",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 0,
  pt: 3,
};

const styleForCreateASN = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "80%", sm: "80%", md: "80%", lg: "90%", xl: "90%" },
  height: "fit-content",
  maxHight: "60%",
  overflow: "auto",
  boxShadow: 24,
  p: 1,
  pt: 3,
};

const styleForDocument = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 340, sm: 340, md: 600, lg: 800, xl: 800 },
  // height: { xs: "70%", sm: "70%", md: "50%", lg: "90%", xl: "90%" },
  overflow: "auto",
  maxHeight: "90%",
  boxShadow: 24,
  p: 1,
  pt: 3,
};

const styleForDocumentPrint = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 340, sm: 340, md: 600, lg: 900, xl: 900 },
  // height: { xs: "70%", sm: "70%", md: "50%", lg: "90%", xl: "90%" },
  overflow: "auto",
  maxHeight: "90%",
  boxShadow: 24,
  p: 1,
  pt: 3,
};

const styles = StyleSheet.create({
  page: {
    width: "100%",
    height: "100%",
    display: "flex",
    // flexDirection: "row",
    marginBottom: "50px",
    marginTop: "50px",
    // backgroundColor: '#E4E4E4'
  },
  section: {
    margin: 2,
    padding: 2,
    flexGrow: 1,
  },
});

const styleForColumnReorder = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 380,
  color: "black",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 2,
  pt: 3,
};
const DailyDemand = ({
  getDailyDemand,
  dailyDemandReducer,
  getDailyDemandForDownload,
  dailyDemandForDownloadReducer,
  getPartNoForPlanner,
  partNoForPlannerReducer,
  getPartNo,
  partNoReducer,
  getPlant,
  plantReducer,
  getPackageType,
  packageTypeReducer,
  createAsn,
  calculatePacketDetails,
  packageDetailsReducer,
  getDeliveryPlant,
  getUnloadingPoint,
  deliveryPlantReducer,
  unloadingPointReducer,
  calculatePacketWeight,
  packetWeightReducer,
  getBinsForPrint,
  binsForPrintReducer,
  uploadCsvForDailyDemand,
  getUnConfirmedMonthlyDemand,
  unConfirmedMonthlyDemandReducer,
  getVendorsListForPlanner,
  vendorsListForPlannerReducer,
  updateActualQty,
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
  getPurchaseOrdersForDemand,
  getPurchaseOrdersForDemandReducer,
  getDynamicColumn,
  createDynamicColumn,
  getDynamicColumnReducer,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  let jwtToken = loginDetails?.jwt;
  let userId = loginDetails?.data.userId;
  let roleName = loginDetails.data.roleName;
  let email = loginDetails.data.email;
  let roleId = loginDetails.data.roleId;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  const subModuleId = "2898761c-f041-41d4-8e59-5c289c28c0ad";

  let dynamicColumnDetails = cookies.get("dynamic-column-data");

  let dailyDemandModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "2898761c-f041-41d4-8e59-5c289c28c0ad",
  );

  let asnCreationAccess = dailyDemandModule
    ? dailyDemandModule.actionId.includes(
        "018f340f-377e-4f1c-ab02-64bc00c44420",
      )
    : null;

  let uploadAccess = dailyDemandModule
    ? dailyDemandModule.actionId.includes(
        "80c8758d-7eef-419e-9b6f-332dc887fd98",
      )
    : null;

  // let viewAccess = dailyDemandModule
  //   ? dailyDemandModule.actionId.includes(
  //       "c0003bb1-3b7e-4adc-a70e-0d63b9a93d7e"
  //     )
  //   : null;

  let viewAccess = true;

  let updatePlanQtyAccess = dailyDemandModule
    ? dailyDemandModule.actionId.includes(
        "62b33f99-b51d-4efc-a9cc-a6ed7829097a",
      )
    : null;

  let downloadAccess = dailyDemandModule
    ? dailyDemandModule.actionId.includes(
        "b4373512-ed39-4c26-9418-0a0b3c50ec92",
      )
    : null;

  let monthlyDemandModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "5fbabc86-10f0-47a3-b160-5ad4b854a642",
  );

  let getNotificationsAccess = monthlyDemandModule
    ? monthlyDemandModule.actionId.includes(
        "8240c359-7f77-4e94-b311-1be6dd7bc6c9",
      )
    : null;

  const [pageNo, setPageNo] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchObject, setSearchObject] = useState(JSON.stringify({}));
  const [paginationObj, setPaginationObj] = useState({});

  const importPageNo = (pageIndex) => {
    setPageNo(pageIndex === -1 ? pageNo : pageIndex);
  };

  const importRowsPerPage = (pageSize) => {
    setRowsPerPage(pageSize);
  };

  const importSearch = (globalFilter) => {
    setSearchObject(globalFilter ? JSON.stringify(globalFilter) : "");
  };

  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const [uploadLoader, setUploadLoader] = useState(false);

  const [partNoSelected, setPartNoSelected] = useState("");
  const [plantSelected, setPlantSelected] = useState("");
  const [vendorsListForPlannerSelected, setVendorsListForPlannerSelected] =
    useState("");
  const [purchaseOrderNumberSelected, setPurchaseOrderNumberSelected] =
    useState("");

  const [asnQtyChange, setAsnQtyChange] = useState("");

  const [invoiceDate, setInvoiceDate] = useState("");

  const [invoiceNo, setInvoiceNo] = useState("");

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  let isoStartDate;
  let isoEndDate;

  useEffect(() => {
    if (startDate || endDate) {
      isoStartDate = new Date(
        (startDate ? startDate : new Date()).getTime() -
          (startDate ? startDate : new Date()).getTimezoneOffset() * 60000,
      ).toISOString();

      const formatDate = (date) => {
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      };

      const formattedStartDate = formatDate(new Date(isoStartDate));

      isoEndDate = new Date(
        (endDate ? endDate : new Date()).getTime() -
          (endDate ? endDate : new Date()).getTimezoneOffset() * 60000,
      ).toISOString();

      const formattedEndDate = formatDate(new Date(isoEndDate));
    }
    // Now you can use both formattedStartDate and formattedEndDate
    let timeout = setTimeout(() => {
      getDailyDemand(
        email,
        partNoSelected ? partNoSelected.value : "",
        plantSelected ? plantSelected.value : "",
        vendorsListForPlannerSelected
          ? vendorsListForPlannerSelected.value
          : "",
        roleName,
        startDate ? startDate : "",
        endDate ? endDate : "",
        purchaseOrderNumberSelected ? purchaseOrderNumberSelected.value : "",
        pageNo,
        rowsPerPage,
        searchObject,
        jwtToken,
      );

      getDailyDemandForDownload(
        email,
        partNoSelected ? partNoSelected.value : "",
        plantSelected ? plantSelected.value : "",
        vendorsListForPlannerSelected
          ? vendorsListForPlannerSelected.value
          : "",
        roleName,
        startDate ? startDate : "",
        endDate ? endDate : "",
        purchaseOrderNumberSelected ? purchaseOrderNumberSelected.value : "",
        pageNo,
        rowsPerPage,
        searchObject,
        jwtToken,
      );
    }, 200);

    return () => clearTimeout(timeout);
  }, [
    partNoSelected,
    plantSelected,
    email,
    vendorsListForPlannerSelected,
    startDate,
    endDate,
    purchaseOrderNumberSelected,
    pageNo,
    rowsPerPage,
    searchObject,
  ]);

  let today = new Date();

  var dd = String(today.getDate()).padStart(2, "0");
  var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
  var yyyy = today.getFullYear();

  let currentDate = yyyy + "-" + mm + "-" + dd;

  useEffect(() => {
    roleName &&
      roleName.toLowerCase() !== "vendor" &&
      getPartNoForPlanner(jwtToken);
  }, []);

  useEffect(() => {
    // roleName == "vendor" &&
    getPartNo(
      vendorsListForPlannerSelected
        ? vendorsListForPlannerSelected.email
        : email,
      jwtToken,
    );
  }, [userId, vendorsListForPlannerSelected]);

  useEffect(() => {
    getPlant(jwtToken);
  }, []);

  const handleChangePartNoForPlanner = (selectedOption) => {
    setPartNoSelected(selectedOption);
  };

  const [partNoForPlannerOptions, setPartNoForPlannerOptions] = useState([]);

  useEffect(() => {
    let tempPartNoForPlannerOptions = [];
    let data = partNoForPlannerReducer.partNoForPlannerData.data
      ? partNoForPlannerReducer.partNoForPlannerData.data
      : [];
    data.map((partNo) => {
      tempPartNoForPlannerOptions.push({
        label: partNo.itemCode,
        value: partNo.itemCode,
      });
    });
    setPartNoForPlannerOptions(tempPartNoForPlannerOptions);
  }, [partNoForPlannerReducer]);

  useEffect(() => {
    getVendorsListForPlanner(jwtToken);
  }, []);

  useEffect(() => {
    getPurchaseOrdersForDemand(email, jwtToken);
  }, [email]);

  const [asnCode, setAsnCode] = useState("");
  const [packageType, setPackageType] = useState("");

  useEffect(() => {
    getBinsForPrint(asnCode, jwtToken);
  }, [asnCode]);

  const [partCode, setPartCode] = useState("");

  const [demandId, setDemandId] = useState("");

  useEffect(() => {
    getPackageType(partCode, jwtToken);
  }, [partCode]);

  useEffect(() => {
    calculatePacketWeight(partCode, asnQtyChange, jwtToken);
  }, [partCode, asnQtyChange]);

  useEffect(() => {
    getDeliveryPlant(demandId, jwtToken);
  }, [demandId]);

  useEffect(() => {
    getUnloadingPoint(demandId, jwtToken);
  }, [demandId]);

  const [singleDeliveryPlantData, setSingleDeliveryPlantData] = useState("");
  const [singleUnloadingPointData, setSingleUnloadingPointData] = useState("");

  const [singleAsnPackageTypeData, setSingleAsnPackageTypeData] = useState("");

  const [singleAsnPackageWeightData, setSingleAsnPackageWeightData] =
    useState("");

  const [singleAsnPackageDetailsData, setSingleAsnPackageDetailsData] =
    useState({});

  useEffect(() => {
    let data = packageTypeReducer.packageTypeData.data
      ? packageTypeReducer.packageTypeData.data
      : [];

    setSingleAsnPackageTypeData(data.packaging);
  }, [packageTypeReducer]);

  useEffect(() => {
    let data = packetWeightReducer.packetWeightData.data
      ? packetWeightReducer.packetWeightData.data
      : [];

    setSingleAsnPackageWeightData(data.packWeight);
  }, [packetWeightReducer]);

  useEffect(() => {
    let data = deliveryPlantReducer.deliveryPlantData.data
      ? deliveryPlantReducer.deliveryPlantData.data
      : [];

    setSingleDeliveryPlantData(data.deliveryPlant);
  }, [deliveryPlantReducer]);

  useEffect(() => {
    let data = unloadingPointReducer.unloadingPointData.data
      ? unloadingPointReducer.unloadingPointData.data
      : [];

    setSingleUnloadingPointData(data.unloadingPoint);
  }, [unloadingPointReducer]);

  useEffect(() => {
    let data = packageDetailsReducer.packageDetailsData.data
      ? packageDetailsReducer.packageDetailsData.data
      : [];
    setSingleAsnPackageDetailsData(data);
  }, [packageDetailsReducer]);

  const handleChangePartNo = (selectedOption) => {
    setPartNoSelected(selectedOption);
  };

  const [partNoOptions, setPartNoOptions] = useState([]);

  useEffect(() => {
    let tempPartNoOptions = [];
    let data = partNoReducer.partNoData.data
      ? partNoReducer.partNoData.data
      : [];
    data.map((partNo) => {
      tempPartNoOptions.push({
        label: partNo.itemCode,
        value: partNo.itemCode,
      });
    });
    setPartNoOptions(tempPartNoOptions);
  }, [partNoReducer]);

  // useEffect(() => {
  //   if (roleName == "vendor") {
  //     setPartNoSelected({
  //       label: partNoOptions[0]?.label,
  //       value: partNoOptions[0]?.value,
  //     });
  //   }
  // }, [partNoOptions]);

  const handleChangePlant = (selectedOption) => {
    setPlantSelected(selectedOption);
  };

  const [plantOptions, setPlantOptions] = useState([]);

  useEffect(() => {
    let tempPlantOptions = [];
    let data = plantReducer.plantData.data ? plantReducer.plantData.data : [];
    data.map((plant) => {
      tempPlantOptions.push({
        label: plant.plantCode,
        value: plant.plantCode,
      });
    });
    setPlantOptions(tempPlantOptions);
  }, [plantReducer]);

  useEffect(() => {
    if (plantOptions) {
      setPlantSelected({
        label: plantOptions[0]?.label,
        value: plantOptions[0]?.value,
      });
    }
  }, [plantOptions]);

  const handleChangeVendorsListForPlanner = (selectedOption) => {
    setVendorsListForPlannerSelected(selectedOption);
    setPartNoSelected("");
  };

  const [vendorsListForPlannerOptions, setVendorsListForPlannerOptions] =
    useState([]);

  useEffect(() => {
    let tempVendorsListForPlannerOptions = [];
    let data = vendorsListForPlannerReducer.vendorsListForPlannerData.data
      ? vendorsListForPlannerReducer.vendorsListForPlannerData.data
      : [];
    data.map((vendorsListForPlanner) => {
      tempVendorsListForPlannerOptions.push({
        label: vendorsListForPlanner.vendorName,
        value: vendorsListForPlanner.vendorCode,
        email: vendorsListForPlanner.email,
        vendorId: vendorsListForPlanner.vendorUserId,
      });
    });
    setVendorsListForPlannerOptions(tempVendorsListForPlannerOptions);
  }, [vendorsListForPlannerReducer]);

  const handleChangePurchaseOrderNumber = (selectedOption) => {
    setPurchaseOrderNumberSelected(selectedOption);
  };

  const [purchaseOrderNumberOptions, setPurchaseOrderNumberOptions] = useState(
    [],
  );

  useEffect(() => {
    let tempPurchaseOrderNumberOptions = [];
    let data = getPurchaseOrdersForDemandReducer.purchaseOrdersForDemand.data
      ? getPurchaseOrdersForDemandReducer.purchaseOrdersForDemand.data
      : [];
    data.map((PurchaseOrderNumber) => {
      tempPurchaseOrderNumberOptions.push({
        label: PurchaseOrderNumber.purchaseOrderNumber,
        value: PurchaseOrderNumber.purchaseOrderNumber,
        email: PurchaseOrderNumber.email,
        vendorId: PurchaseOrderNumber.vendorUserId,
      });
    });
    setPurchaseOrderNumberOptions(tempPurchaseOrderNumberOptions);
  }, [getPurchaseOrdersForDemandReducer]);

  const packageTypeOptions = [
    { label: "Bin", value: "Bin" },
    // { label: "Can", value: "Can" },
    { label: "Carton", value: "Carton" },
    { label: "Container", value: "Container" },
  ];

  const [packageTypeSelected, setPackageTypeSelected] = useState("");
  const handleChangePackageType = (selectedOption) => {
    setPackageTypeSelected(selectedOption);
  };

  const [state, setState] = useState({
    columns: [
      { Header: "SR No", accessor: "id", align: "left" },
      { Header: "Date", accessor: "date", align: "left" },
      { Header: "Po No", accessor: "purchaseOrderNumber", align: "left" },
      {
        Header: "Po Line Item",
        accessor: "purchaseOrderLineNumber",
        align: "left",
      },
      { Header: "Part No", accessor: "itemCode", align: "left" },
      {
        Header: "Part Description",
        accessor: "itemDescription",
        align: "left",
      },
      { Header: "Schedule QTY", accessor: "scheduleQty", align: "left" },
      { Header: "Balance QTY", accessor: "balanceQty", align: "left" },

      {
        Header: "Action",
        accessor: "action",
        align: "center",
        cannotSearch: true,
        cannotSort: true,
      },
    ],
    rows: [],
  });

  const [stateForPlanner, setStateForPlanner] = useState({
    columns: [
      { Header: "SR No", accessor: "id", align: "left" },
      { Header: "Date", accessor: "date", align: "left" },
      { Header: "Po No", accessor: "purchaseOrderNumber", align: "left" },
      {
        Header: "Po Line Item",
        accessor: "purchaseOrderLineNumber",
        align: "left",
      },
      { Header: "Part No", accessor: "itemCode", align: "left" },
      {
        Header: "Part Description",
        accessor: "itemDescription",
        align: "left",
      },
      { Header: "Schedule QTY", accessor: "scheduleQty", align: "left" },
      { Header: "Balance QTY", accessor: "balanceQty", align: "left" },

      {
        Header: "Action",
        accessor: "action",
        align: "center",
        cannotSearch: true,
        cannotSort: true,
      },
    ],
    rows: [],
  });

  const { columns, rows } = roleName == "vendor" ? state : stateForPlanner;

  // const [itemTable, setItemTable] = useState({
  //   columns: [
  //     { Header: "ASN Code", accessor: "asnCode", align: "left" },
  //     { Header: "Bin Code", accessor: "binCode", align: "left" },
  //     { Header: "QTY", accessor: "qty", align: "left" },
  //     // { Header: "Quantity", accessor: "quantity", align: "left" },
  //     // { Header: "NOB", accessor: "nob", align: "left" },
  //     // { Header: "LOT/Serial No", accessor: "lotSerialNo", align: "left" },
  //     // { Header: "Item Category", accessor: "itemCategory", align: "left" },
  //     { Header: "QR Code", accessor: "action", align: "center" },
  //   ],
  //   rows: [],
  // });

  // const { columns: itemColumns, rows: itemRows } = itemTable;

  const [printData, setPrintData] = useState([]);

  const [loading, setLoading] = useState(true);
  let dailyDemandReducers = dailyDemandReducer;

  useEffect(() => {
    let tempDailyDemand = [];
    let data = dailyDemandReducer.dailyDemandData.data
      ? dailyDemandReducer.dailyDemandData.data
      : [];
    setLoading(dailyDemandReducer.loading);
    setPaginationObj(dailyDemandReducer?.dailyDemandData?.pagination);
    data.map((singleData) => {
      let des = singleData?.itemDescription;
      let len = desLength;
      const formatDate = new Date(singleData.date);

      const dataObject = {
        id: singleData.demandId,
        partNoDes: `${singleData.itemCode} / ${
          des ? des.substring(0, len) : ""
        }`,
        partCode: singleData.itemCode,
        itemCode: singleData.itemCode,
        partDescription: singleData.itemDescription,
        itemDescription: singleData.itemDescription,
        deliveryPlant: singleData.deliveryPlant,
        unloadingPoint: singleData.unloadingPoint,
        vendorCode: singleData.vendorCode,
        scheduleQty: singleData.scheduleQty,
        balanceQty: singleData.balanceQty,
        purchaseOrderNumber: singleData.purchaseOrderNumber,
        purchaseOrderLineNumber: singleData.purchaseOrderLineNumber,
        // date: format(
        //   addMinutes(formatDate, formatDate.getTimezoneOffset()),
        //   "do MMMM yyyy"
        // ),
        date: singleData.date,

        action: (
          <div>
            {/* {role == "vendor" ? ( */}
            {singleData.enable && asnCreationAccess ? (
              <Tooltip title="ASN Creation">
                <MDButton
                  variant="gradient"
                  color="info"
                  type="button"
                  onClick={() => {
                    setPartCode(singleData.itemCode);
                    setDemandId(singleData?.demandId);

                    handleOpenCreateASNModal(singleData);
                  }}
                  style={{ marginRight: "5px", padding: "2%" }}
                >
                  <Icon style={{ marginRight: "2px" }}>add</Icon>
                  ASN
                </MDButton>
              </Tooltip>
            ) : (
              <Tooltip title="ASN Creation">
                <MDButton
                  disabled
                  variant="gradient"
                  color="info"
                  type="button"
                  onClick={() => {
                    setPartCode(singleData.itemCode);
                    setDemandId(singleData.demandId);
                    setPartCode(singleData.itemCode);
                    handleOpenCreateASNModal(singleData);
                  }}
                  style={{ marginRight: "5px", padding: "2%" }}
                >
                  <Icon style={{ marginRight: "2px" }}>add</Icon>
                  ASN
                </MDButton>
              </Tooltip>
            )}
            {updatePlanQtyAccess && (
              <Tooltip title="Update Qty">
                <MDButton
                  variant="gradient"
                  color="success"
                  iconOnly
                  type="button"
                  onClick={() => handleOpenUpdateActualQtyModal(singleData)}
                  style={{ marginRight: "5px" }}
                >
                  <Icon>edit_sharp</Icon>
                </MDButton>
              </Tooltip>
            )}
          </div>
        ),
      };
      tempDailyDemand.push(dataObject);
    });
    viewAccess &&
      (roleName == "vendor"
        ? setState({ ...state, rows: tempDailyDemand })
        : setStateForPlanner({ ...stateForPlanner, rows: tempDailyDemand }));
  }, [dailyDemandReducer]);

  const [download, setDownload] = useState(true);
  useEffect(() => {
    let tempDailyDemand = [];
    let data = dailyDemandForDownloadReducer.dailyDemandDataForDownload.data
      ? dailyDemandForDownloadReducer.dailyDemandDataForDownload.data
      : [];
    setLoading(dailyDemandForDownloadReducer.loading);
    setPaginationObj(
      dailyDemandForDownloadReducer?.dailyDemandDataForDownload?.pagination,
    );
    data.map((singleData) => {
      let des = singleData?.itemDescription;
      let len = desLength;
      const formatDate = new Date(singleData.date);

      const dataObject = {
        id: singleData.demandId,
        partNoDes: `${singleData.itemCode} / ${
          des ? des.substring(0, len) : ""
        }`,
        partCode: singleData.itemCode,
        itemCode: singleData.itemCode,
        partDescription: singleData.itemDescription,
        itemDescription: singleData.itemDescription,
        deliveryPlant: singleData.deliveryPlant,
        unloadingPoint: singleData.unloadingPoint,
        vendorCode: singleData.vendorCode,
        scheduleQty: singleData.scheduleQty,
        balanceQty: singleData.balanceQty,
        purchaseOrderNumber: singleData.purchaseOrderNumber,
        purchaseOrderLineNumber: singleData.purchaseOrderLineNumber,
        // date: format(
        //   addMinutes(formatDate, formatDate.getTimezoneOffset()),
        //   "do MMMM yyyy"
        // ),
        date: singleData.date,
      };
      tempDailyDemand.push(dataObject);
    });
    setDownload(tempDailyDemand);
  }, [dailyDemandForDownloadReducer]);

  useEffect(() => {
    let tempBins = [];
    let data = binsForPrintReducer.binsForPrintData.data
      ? binsForPrintReducer.binsForPrintData.data
      : [];

    setPrintData(data);
  }, [binsForPrintReducer]);

  // const [showFilters, setShowFilters] = useState(false);

  // const showFiltersHandler = () => {
  //   setShowFilters(!showFilters);
  // };

  // const changeGrn = (selectedData) => {
  //   setGrnIdSelected(selectedData);
  // };

  // const changeWarehouse = (selectedData) => {
  //   setWarehouseIdSelected(selectedData);
  // };

  const AsnCreationNotification = () =>
    toast.success("Asn Created Successfully", {
      position: "top-center",
      autoClose: 2000,
    });

  const [isErrorCreatePickupList, setIsErrorCreatePickupList] = useState(false);

  useEffect(() => {
    if (isErrorCreatePickupList) {
      setTimeout(() => {
        setIsErrorCreatePickupList(false);
      }, 3000);
    }
  }, [isErrorCreatePickupList]);

  const [openCreatePickupListModal, setOpenCreatePickupListModal] =
    useState(false);

  const [pickupListData, setPickupListData] = useState({});

  const handleOpenCreatePickupListModal = (data = {}) => {
    setPickupListData(data);
    setOpenCreatePickupListModal(true);
  };

  const handleCloseCreatePickupListModal = () => {
    setOpenCreatePickupListModal(false);
  };

  const createPickupListHandler = (event, data) => {
    handleOpenCreatePickupListModal(data);
  };

  const [selectedPickupListData, setSelectedPickupListData] = useState([]);
  const [uncheck, setUncheck] = useState(false);

  const PickupListData = (data) => {
    setSelectedPickupListData(data);
  };

  const onClickCreatePickupList = async () => {
    let transactionCode = [];

    selectedPickupListData.map((data) => {
      const object = {
        transactionCode: data.transactionNo,
      };
      transactionCode.push(object);
    });

    // let res = await createPickupList(transactionCode);

    // if (res.status) {
    //   handleCloseCreatePickupListModal();
    //   getCreatePickupList(warehouseIdSelected?.value);
    //   CreatePickupListSuccessNotification();
    // }
    // if (!res.status) {
    //   setIsErrorCreatePickupList(true);
    // }
  };

  const [fileForTestCertificate, setFileForTestCertificate] = useState({});

  const handleChangeForTestCertificate = (event) => {
    setFileForTestCertificate(event.target.files[0]);
  };

  const [fileForInvoiceFile, setFileForInvoiceFile] = useState({});

  const handleChangeForInvoiceFile = (event) => {
    setFileForInvoiceFile(event.target.files[0]);
  };

  //   const packageDetailsHandler = async () => {

  // let payload = {
  //   // asnQty: asnQtyChange,
  //   // partCode: partCode
  //   asnQty: "80",
  //   partCode: "M792.636.000"
  // }
  //     let res = await calculatePacketDetails(payload, jwtToken);

  //     if (res.status) {
  //       setSingleAsnPackageDetailsData(res.data);

  //     }
  //     if (!res.status) {

  //     }
  //   };

  const [openCreateASNModal, setOpenCreateASNModal] = useState(false);

  const [singleASNData, setSingleASNData] = useState({});
  const handleOpenCreateASNModal = (ActualQty = {}) => {
    setSingleASNData(ActualQty);

    setOpenCreateASNModal(true);
    setIsErrorCreateASN(false);
    setIsSuccessCreateASN(false);
  };
  const handleCloseCreateASNModal = () => {
    setOpenCreateASNModal(false);
    formik.setValues(initialValues);
    formik.setTouched({});
    formik.setErrors({});
    setAsnQtyChange("");
    // window.location.reload();
  };

  const [createAsnError, setCreateAsnError] = useState("");

  const [isErrorCreateASN, setIsErrorCreateASN] = useState(false);
  const [isSuccessCreateASN, setIsSuccessCreateASN] = useState(false);

  useEffect(() => {
    if (isErrorCreateASN) {
      setTimeout(() => {
        setIsErrorCreateASN(false);
      }, 3000);
    }
  }, [isErrorCreateASN]);

  useEffect(() => {
    if (isSuccessCreateASN) {
      setTimeout(() => {
        setIsSuccessCreateASN(false);
      }, 3000);
    }
  }, [isSuccessCreateASN]);

  const initialValues = {
    demandId: singleASNData ? singleASNData.id : "",
    partNoDes: `${singleASNData ? singleASNData.itemCode : ""}/${
      singleASNData ? singleASNData.itemDescription : ""
    }`,
    poNoLineNo: `${singleASNData ? singleASNData.purchaseOrderNumber : ""}/${
      singleASNData ? singleASNData.purchaseOrderLineNumber : ""
    }`,
    scheduleQuantity: singleASNData ? singleASNData.scheduleQty : "",
    asnQty: asnQtyChange ? asnQtyChange : "",
    balanceQty: singleASNData ? singleASNData.balanceQty : "",
    unloadingPoint: singleUnloadingPointData ? singleUnloadingPointData : "",
    deliveryPlant: singleDeliveryPlantData ? singleDeliveryPlantData : "",
    packageType: singleAsnPackageTypeData ? singleAsnPackageTypeData : "",
    packetNo: "",

    packetWeight: "",
    invoiceNo: singleASNData ? singleASNData.invoiceNo : "",
    invoiceDate: singleASNData ? singleASNData.invoiceDate : "",
    // invoiceFile: "",
    planDate: "",
  };

  const validationSchema = Yup.object({
    // partNoDes: Yup.string().required("Enter Part No/Description"),
    // poNoLineNo: Yup.string().required("Enter Po No/Line Number"),
    // scheduleQuantity: Yup.string().required("Enter Schedule Quantity"),
    asnQty: Yup.number()
      .min(1)
      .max(singleASNData.balanceQty)
      .required("Enter a valid ASN quantity"),
    // invoiceNo: Yup.string().required("Enter Invoice No"),
    // invoiceDate: Yup.string().required("Enter Invoice Date"),
    // // deliveryPlant: Yup.string()
    // //   .required("Enter a experience")
    // //   .min(1, "Invalid data")
    // //   .max(2, "Invalid data")
    // //   .test("Is positive", "must be positive", (val) => val >= 0),
    // deliveryPlant: Yup.string().required("Select Delivery Plant"),
    // typeOfPacket: Yup.string().required("Select Type of Packet"),
    // noOfPacket: Yup.string().required("Enter No of Packet"),
    // unitPackQuantity: Yup.string().required("Enter Unit Pack Quantity"),
    // unitPacketWeight: Yup.string().required("Enter Unit Packet Weight"),
  });

  // const handleChange = (event) => {
  //   setjobDescFile(event.target.files[0]);
  // };

  const [buttonNameForCreateAsn, setButtonNameForCreateAsn] =
    useState("Create ASN");

  const onSubmit = async (values, { resetForm }) => {
    setButtonNameForCreateAsn("Please wait...");
    let payload = {
      testCertificate: fileForTestCertificate,
      invoice: fileForInvoiceFile,
      invoiceNo: invoiceNo,
      invoiceDate: invoiceDate,
      planDate: singleASNData ? singleASNData.date : "",
      partNoDes: values.partNoDes,
      poNoLineNo: values.poNoLineNo,
      asnQty: values.asnQty,
      packageType: singleAsnPackageTypeData,
      packetNo: singleAsnPackageDetailsData.packetQty,
      packetWeight: singleAsnPackageWeightData,
      unloadingPoint: singleUnloadingPointData,
      deliveryPlant: singleDeliveryPlantData,
      demandId: singleASNData ? singleASNData.demandId : "",
      email: email,
    };

    let response = await createAsn(payload, jwtToken);

    if (response.status === true) {
      setAsnCode(response.data.data.asnCode);
      setPackageType(response.data.data.packageType);

      setIsSuccessCreateASN(true);
      AsnCreationNotification();
      setTimeout(() => {
        setButtonNameForCreateAsn("Create ASN");
      }, 2250);
      // handleCloseCreateASNModal();
      getDailyDemand(
        email,
        partNoSelected ? partNoSelected.value : "",
        plantSelected ? plantSelected.value : "",
        vendorsListForPlannerSelected
          ? vendorsListForPlannerSelected.value
          : "",
        roleName,
        startDate ? startDate : "",
        endDate ? endDate : "",
        purchaseOrderNumberSelected ? purchaseOrderNumberSelected.value : "",
        pageNo,
        rowsPerPage,
        searchObject,
        jwtToken,
      );
      getAsnDetails(email, jwtToken);
      resetForm();
    }
    if (response.status === false) {
      setIsErrorCreateASN(true);
      setButtonNameForCreateAsn("Create ASN");
      setCreateAsnError(response?.data?.data?.msg);
    }
  };

  const formik = useFormik({
    initialValues,
    onSubmit,
    validationSchema,
    enableReinitialize: true,
  });

  const [printAsnDetailsPartCode, setPrintAsnDetailsPartCode] = useState("");
  const [printAsnDetailsInvoiceNo, setPrintAsnDetailsInvoiceNo] = useState("");
  const [printAsnDetailsTransporterName, setPrintAsnDetailsTransporterName] =
    useState("");
  const [printAsnDetailsVehicleNameplate, setPrintAsnDetailsVehicleNameplate] =
    useState("");
  const [printAsnDetailsTransporterType, setPrintAsnDetailsTransporterType] =
    useState("");
  const [printAsnDetailsLRNumber, setPrintAsnDetailsLRNumber] = useState("");
  const [printAsnDetailsPhoneNumber, setPrintAsnDetailsPhoneNumber] =
    useState("");

  const [buttonName, setButtonName] = useState("Submit");

  const [openPrintASNModal, setOpenPrintASNModal] = useState(false);

  const handleClosePrintASNModal = () => {
    setOpenPrintASNModal(false);
  };

  const handleOpenPrintASNModal = () => {
    setOpenPrintASNModal(true);
  };

  const [show, setShow] = useState(false);

  const toggleSnackbar = () => setShow(!show);

  const DataUploadSuccessNotification = () =>
    toast.success("Data Uploaded Successfully", {
      position: "top-center",
      autoClose: 2000,
    });

  const DataUploadFailureNotification = (data) =>
    toast.error(data, {
      position: "top-center",
      autoClose: 2000,
    });

  const ConfirmCnfAlertNotification = () =>
    toast.error("Please Go To Monthly Demand And Confirm Actual Qty", {
      position: "top-center",
      autoClose: false,
      hideProgressBar: true,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });

  useEffect(() => {
    getNotificationsAccess && getUnConfirmedMonthlyDemand(userId, jwtToken);
  }, [userId]);

  useEffect(() => {
    let data = unConfirmedMonthlyDemandReducer.unConfirmedMonthlyDemandData.data
      ? unConfirmedMonthlyDemandReducer.unConfirmedMonthlyDemandData.data
      : [];

    let dataLenght = unConfirmedMonthlyDemandReducer
      .unConfirmedMonthlyDemandData.data
      ? unConfirmedMonthlyDemandReducer.unConfirmedMonthlyDemandData.data.length
      : [];

    if (dataLenght > 0) {
      // ConfirmCnfAlertNotification();
      setShow(true);
    }
  }, [unConfirmedMonthlyDemandReducer]);

  const [uploadCsvFilter, setUploadCsvFilter] = useState(false);

  const uploadCsvFilterHandler = () => {
    setUploadCsvFilter(!uploadCsvFilter);
  };

  const [uploadCsvData, setUploadCsvData] = useState({});

  const uploadCsvHandler = async () => {
    setUploadLoader(true);

    let data = new FormData();

    data.append("file", uploadCsvData);

    let res = await uploadCsvForDailyDemand(data, jwtToken);

    if (res.status) {
      setUploadLoader(false);

      getDailyDemand(
        email,
        partNoSelected ? partNoSelected.value : "",
        plantSelected ? plantSelected.value : "",
        vendorsListForPlannerSelected
          ? vendorsListForPlannerSelected.value
          : "",
        roleName,
        startDate,
        endDate,
        purchaseOrderNumberSelected ? purchaseOrderNumberSelected.value : "",
        pageNo,
        rowsPerPage,
        searchObject,
        jwtToken,
      );
      setUploadCsvFilter(false);
      DataUploadSuccessNotification();
    }
    if (!res.status) {
      setUploadLoader(false);
      DataUploadFailureNotification(res?.data?.data?.msg);
    }
  };

  const [openUpdateActualQtyModal, setOpenUpdateActualQtyModal] =
    useState(false);
  const [
    singleMonthlyDemandDataForUpdate,
    setSingleMonthlyDemandDataForUpdate,
  ] = useState({});
  const handleOpenUpdateActualQtyModal = (ActualQty = {}) => {
    setSingleMonthlyDemandDataForUpdate(ActualQty);
    setOpenUpdateActualQtyModal(true);
    setIsErrorForUpdate(false);
    setIsSuccessForUpdate(false);
  };
  const handleCloseUpdateActualQtyModal = () => {
    setOpenUpdateActualQtyModal(false);

    formikForUpdate.setValues(initialValueForUpdate);
    formikForUpdate.setTouched({});
    formikForUpdate.setErrors({});
  };

  const [errorMsgForUpdateQty, setErrorMsgForUpdateQty] = useState("");

  const [isErrorForUpdate, setIsErrorForUpdate] = useState(false);
  const [isSuccessForUpdate, setIsSuccessForUpdate] = useState(false);

  useEffect(() => {
    if (isErrorForUpdate) {
      setTimeout(() => {
        setIsErrorForUpdate(false);
      }, 3000);
    }
  }, [isErrorForUpdate]);

  useEffect(() => {
    if (isSuccessForUpdate) {
      setTimeout(() => {
        setIsSuccessForUpdate(false);
      }, 3000);
    }
  }, [isSuccessForUpdate]);

  const initialValueForUpdate = {
    // departmentId: singleDepartmentDataForUpdate.departmentId,
    actualQty: singleMonthlyDemandDataForUpdate.actualQty,
    remark: singleMonthlyDemandDataForUpdate.remark,
  };

  const validationSchemaForUpdate = Yup.object({
    actualQty: Yup.number().required("Enter a valid Qty"),
  });

  const onSubmitForUpdate = async (values) => {
    setButtonName("Please wait...");
    let payload = {
      // partCode: singleMonthlyDemandDataForUpdate.itemCode,
      // planDate: singleMonthlyDemandDataForUpdate.date,
      demandId: singleMonthlyDemandDataForUpdate.demandId,
      qty: values.actualQty,
      userId: userId,
    };

    let res = await updateActualQty(payload, jwtToken);

    if (res.status) {
      setIsSuccessForUpdate(true);
      setTimeout(() => {
        handleCloseUpdateActualQtyModal();
        setButtonName("Submit");
      }, 3000);

      getDailyDemand(
        email,
        partNoSelected ? partNoSelected.value : "",
        plantSelected ? plantSelected.value : "",
        vendorsListForPlannerSelected
          ? vendorsListForPlannerSelected.value
          : "",
        roleName,
        startDate,
        endDate,
        purchaseOrderNumberSelected ? purchaseOrderNumberSelected.value : "",
        pageNo,
        rowsPerPage,
        searchObject,
        jwtToken,
      );
    }
    if (!res.status) {
      setIsErrorForUpdate(true);
      setErrorMsgForUpdateQty(
        res.data.data.message ? res.data.data.message : res?.data?.data?.msg,
      );
      setButtonName("Submit");
    }
  };

  const formikForUpdate = useFormik({
    initialValues: initialValueForUpdate,
    onSubmit: onSubmitForUpdate,
    validationSchema: validationSchemaForUpdate,
    enableReinitialize: true,
  });

  const headers = [
    {
      label: "date",
      key: "date",
    },
    {
      label: "scheduleQty",
      key: "scheduleQty",
    },

    {
      label: "vendorCode",
      key: "vendorCode",
    },
    {
      label: "itemCode",
      key: "itemCode",
    },

    {
      label: "unloadingPoint",
      key: "unloadingPoint",
    },
    {
      label: "deliveryPlant",
      key: "deliveryPlant",
    },
    {
      label: "purchaseOrderNumber",
      key: "purchaseOrderNumber",
    },
    {
      label: "purchaseOrderLineNumber",
      key: "purchaseOrderLineNumber",
    },
  ];

  const headers2 = [
    {
      label: "date",
      key: "date",
    },
    {
      label: "scheduleQty",
      key: "scheduleQty",
    },
    {
      label: "balanceQty",
      key: "balanceQty",
    },
    {
      label: "vendorCode",
      key: "vendorCode",
    },
    {
      label: "itemCode",
      key: "itemCode",
    },
    {
      label: "itemDescription",
      key: "itemDescription",
    },
    {
      label: "unloadingPoint",
      key: "unloadingPoint",
    },
    {
      label: "deliveryPlant",
      key: "deliveryPlant",
    },
    {
      label: "purchaseOrderNumber",
      key: "purchaseOrderNumber",
    },
    {
      label: "purchaseOrderLineNumber",
      key: "purchaseOrderLineNumber",
    },
  ];

  const csvLink = {
    filename: "Daily Demand.csv",
    headers: headers,
    data: [],
  };

  const csvLink2 = {
    filename: "Daily Demand.csv",
    headers: headers2,
    data: download,
  };

  const [loadingForDynamicColumn, setLoadingForDynamicColumn] = useState(false);
  useEffect(() => {
    getDynamicColumn(userId, subModuleId, jwtToken);
  }, [userId, subModuleId]);

  const [dynamicColumnData, setDynamicColumnData] = useState("");

  let hiddenColumsDetails = cookies.get("hidden-column-data");
  useEffect(() => {
    let data = getDynamicColumnReducer.dynamicColumn.data
      ? getDynamicColumnReducer.dynamicColumn.data
      : [];

    setDynamicColumnData(data);
    cookies.set("hidden-column-data", JSON.stringify(data?.notVisibleFields), {
      path: "/",
    });

    setTimeout(() => {
      setLoadingForDynamicColumn(true);
    }, 1000);
  }, [getDynamicColumnReducer, loading]);

  const [openCreateColumnReorderModal, setOpenCreateColumnReorderModal] =
    useState(false);

  const handleOpenCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(true);
  };

  const handleCloseCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(false);
  };

  const [isErrorColumnReorder, setIsErrorColumnReorder] = useState(false);
  const [isSuccessColumnReorder, setIsSuccessColumnReorder] = useState(false);

  useEffect(() => {
    if (isErrorColumnReorder) {
      setTimeout(() => {
        setIsErrorColumnReorder(false);
      }, 3000);
    }
  }, [isErrorColumnReorder]);

  useEffect(() => {
    if (isSuccessColumnReorder) {
      setTimeout(() => {
        setIsSuccessColumnReorder(false);
      }, 3000);
    }
  }, [isSuccessColumnReorder]);

  const [isErrorMsgForColumnReorder, setIsErrorMsgForColumnReorder] =
    useState(false);

  const handleDynamicColumn = async () => {
    let res = await createDynamicColumn(dynamicColumnDetails, jwtToken);
    if (res.status) {
      setIsSuccessColumnReorder(true);
      getDynamicColumn(userId, subModuleId, jwtToken);
      getDailyDemand(
        email,
        partNoSelected ? partNoSelected.value : "",
        plantSelected ? plantSelected.value : "",
        vendorsListForPlannerSelected
          ? vendorsListForPlannerSelected.value
          : "",
        roleName,
        startDate ? startDate : "",
        endDate ? endDate : "",
        purchaseOrderNumberSelected ? purchaseOrderNumberSelected.value : "",
        pageNo,
        rowsPerPage,
        searchObject,
        jwtToken,
      );
      setTimeout(() => {
        handleCloseCreateColumnReorderModal();
        // window.location.reload();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorColumnReorder(true);
      setIsErrorMsgForColumnReorder(res?.data?.data?.msg);
    }
  };

  return (
    <MDBox pt={0} pb={3}>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Card>
            <MDBox
              display="flex"
              flexDirection={{ xs: "column", lg: "row" }}
              justifyContent="space-between"
              alignItems="center"
              p={3}
              mb={-5}
              mt={-4}
            >
              <Grid container spacing={2}>
                <Grid item xs={8}>
                  <MDBox>
                    <MDBox
                      display="flex"
                      mt={2}
                      flexDirection={{ xs: "column", lg: "row" }}
                    >
                      {roleName && roleName.toLowerCase() !== "vendor" && (
                        <MDBox
                          width={{ xs: "250px", lg: "800px" }}
                          style={{ marginRight: "10px" }}
                        >
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: 500 }}
                          >
                            Vendors
                          </MDTypography>
                          <Select
                            isClearable
                            placeholder="Vendors"
                            className="select-css-for-filter"
                            value={vendorsListForPlannerSelected}
                            options={vendorsListForPlannerOptions}
                            onChange={handleChangeVendorsListForPlanner}
                            autoComplete="off"
                          />
                        </MDBox>
                      )}
                      {roleName && roleName.toLowerCase() === "vendor" && (
                        <MDBox style={{ width: "300px", marginRight: "10px" }}>
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: 500 }}
                          >
                            PO Number
                          </MDTypography>
                          <Select
                            isClearable
                            placeholder="PO Number"
                            className="select-css-for-filter"
                            value={purchaseOrderNumberSelected}
                            options={purchaseOrderNumberOptions}
                            onChange={handleChangePurchaseOrderNumber}
                            autoComplete="off"
                          />
                        </MDBox>
                      )}
                      <MDBox
                        width={{ xs: "250px", lg: "350px" }}
                        style={{ marginRight: "10px" }}
                      >
                        <MDTypography variant="h6" style={{ fontWeight: 500 }}>
                          Part Code
                        </MDTypography>
                        {roleName !== "vendor" ? (
                          <Select
                            isClearable
                            placeholder="Part No"
                            className="select-css-for-filter"
                            value={partNoSelected}
                            options={
                              vendorsListForPlannerSelected
                                ? partNoOptions
                                : partNoForPlannerOptions
                            }
                            onChange={handleChangePartNo}
                            autoComplete="off"
                          />
                        ) : (
                          <Select
                            isClearable
                            placeholder="Part No"
                            className="select-css-for-filter"
                            value={partNoSelected}
                            options={partNoOptions}
                            onChange={handleChangePartNo}
                            autoComplete="off"
                          />
                        )}
                      </MDBox>
                      <MDBox style={{ width: "250px", marginRight: "10px" }}>
                        <MDTypography variant="h6" style={{ fontWeight: 500 }}>
                          Plant
                        </MDTypography>
                        <Select
                          isDisabled={true}
                          placeholder="Plant"
                          className="select-css-for-filter"
                          value={plantSelected}
                          options={plantOptions}
                          onChange={handleChangePlant}
                          autoComplete="off"
                        />
                      </MDBox>

                      {roleName === "vendor" && (
                        <MDBox>
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: 500 }}
                          >
                            Start Date
                          </MDTypography>
                          <DatePicker
                            className="form-control"
                            dateFormat="dd/MM/yyyy"
                            placeholderText="Start Date"
                            minDate={new Date()}
                            onChange={(date) => setStartDate(date)}
                            isClearable={true}
                            // withPortal
                            selectsStart
                            selected={startDate}
                            startDate={startDate}
                            endDate={endDate}
                          />
                        </MDBox>
                      )}
                      {roleName === "vendor" && (
                        <MDBox ml={1}>
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: 500 }}
                          >
                            End Date
                          </MDTypography>
                          <DatePicker
                            // disabled={!startDate}
                            className="form-control"
                            dateFormat="dd/MM/yyyy"
                            placeholderText="End Date"
                            // maxDate={new Date()}
                            onChange={(date) => setEndDate(date)}
                            isClearable={true}
                            // withPortal
                            selectsEnd
                            selected={endDate}
                            startDate={startDate}
                            endDate={endDate}
                            minDate={!startDate ? new Date() : startDate}
                          />
                        </MDBox>
                      )}
                    </MDBox>
                  </MDBox>
                </Grid>

                <Grid item xs={8} lg={4}>
                  <MDBox
                    color="text"
                    px={2}
                    display="flex"
                    flexDirection="column"
                  >
                    <MDBox
                      display="flex"
                      marginLeft={0}
                      marginTop="6px"
                      marginBottom="5px"
                    >
                      {/* {uploadAccess && (
                        <CSVLink {...csvLink}>
                          <Tooltip>
                            <DownloadButton
                              tooltip="Download Template"
                              style={{ marginRight: "0.5rem" }}
                              type="button"
                              variant="outlined"
                              color="error"
                              iconOnly
                              title="Download Template"
                            >
                              <Icon>download</Icon>
                            </DownloadButton>
                          </Tooltip>
                        </CSVLink>
                      )} */}
                      {downloadAccess && (
                        <CSVLink {...csvLink2}>
                          <Tooltip>
                            <DownloadDataButton
                              tooltip="Download All Data"
                              style={{ marginRight: "0.5rem" }}
                              type="button"
                              variant="outlined"
                              color="success"
                              iconOnly
                              title="Download All Data"
                            >
                              <Icon>download</Icon>
                            </DownloadDataButton>
                          </Tooltip>
                        </CSVLink>
                      )}

                      {/* {uploadAccess && (
                        <Tooltip>
                          <UploadButton
                            tooltip="Upload CSV"
                            type="button"
                            variant="outlined"
                            color="info"
                            iconOnly
                            onClick={uploadCsvFilterHandler}
                            title="Upload CSV"
                          >
                            <Icon>upload</Icon>
                          </UploadButton>
                        </Tooltip>
                      )} */}
                    </MDBox>
                    <MDBox mr={2}>
                      {uploadCsvFilter && (
                        <div>
                          <div>
                            <input
                              className="choose_file"
                              type="file"
                              accept=".csv"
                              onChange={(e) => {
                                setUploadCsvData(e.target.files[0]);
                              }}
                            />
                            <MDButton
                              disabled={
                                !uploadCsvData?.name ||
                                uploadCsvData?.type !== "text/csv"
                              }
                              variant="contained"
                              color="info"
                              style={{
                                marginLeft: "0",
                                marginTop: "0.3rem",
                                padding: 1,
                                height: "10px",
                              }}
                              type="button"
                              onClick={uploadCsvHandler}
                            >
                              Upload
                            </MDButton>
                          </div>
                          <div>
                            <span
                              style={{
                                color: "red",
                                fontSize: "14px",
                                marginLeft: "0px",
                                fontStyle: "italic",
                              }}
                            >
                              <strong>*</strong> Please upload
                              <strong>".csv"</strong> file only
                            </span>
                          </div>
                        </div>
                      )}
                    </MDBox>
                  </MDBox>
                </Grid>
              </Grid>
            </MDBox>

            <MDBox pt={1}>
              <DataTable
                table={{ columns, rows }}
                isSorted
                tableSearch
                showTotalEntries
                noEndBorder
                loading={loading}
                entriesPerPage={{
                  defaultValue: 5,
                  entries: [5, 10, 15, 20, 25, 30],
                }}
                serverSidePagination
                paginationObj={paginationObj}
                pageNoValue={pageNo}
                rowsPerPageValue={rowsPerPage}
                pageNoProp={importPageNo}
                rowsPerPageProp={importRowsPerPage}
                searchProp={importSearch}
                visibleColumns2={dynamicColumnData?.visibleFields}
                dynamicColumnData={dynamicColumnData}
                /* Table options */
                options={{ draggable: false }}
                /* Column reorder */
                handleOpenCreateColumnReorderModal={
                  handleOpenCreateColumnReorderModal
                }
                /* Meta */
                subModuleId={subModuleId}
                userId={userId}
              />
            </MDBox>

            <Modal
              open={openCreateColumnReorderModal}
              onClose={handleCloseCreateColumnReorderModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
              style={{ backdropFilter: "blur(5px)" }}
            >
              <MDCard sx={styleForColumnReorder}>
                <MDTypography>Are you sure you want to submit?</MDTypography>
                <MDBox mt={2}>
                  <MDButton
                    style={{ width: "10rem", marginRight: "0.5rem" }}
                    color="info"
                    variant="outlined"
                    onClick={handleCloseCreateColumnReorderModal}
                  >
                    Cancel
                  </MDButton>
                  <MDButton
                    style={{ width: "10rem", marginLeft: "0.5rem" }}
                    color="success"
                    onClick={handleDynamicColumn}
                    // disabled={denyButtonName === "Please wait..."}
                  >
                    Submit
                  </MDButton>
                </MDBox>
                <MDBox mt={2}>
                  <Collapse in={isSuccessColumnReorder}>
                    <Alert
                      severity="success"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsSuccessColumnReorder(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      Data updated successfully!
                    </Alert>
                  </Collapse>
                  <Collapse in={isErrorColumnReorder}>
                    <Alert
                      severity="error"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsErrorColumnReorder(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      {isErrorMsgForColumnReorder}
                    </Alert>
                  </Collapse>
                </MDBox>
              </MDCard>
            </Modal>
            <Modal
              open={openCreateASNModal}
              onClose={handleCloseCreateASNModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={styleForCreateASN}>
                <MDBox ml={1} mt={-1} display="flex" alignItems="center">
                  <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                    Create ASN
                  </MDTypography>
                  <MDBox>
                    <Tooltip title="Close">
                      <IconButton
                        aria-label="close"
                        color="inherit"
                        onClick={handleCloseCreateASNModal}
                        style={{
                          background: "whitesmoke",
                          color: "black",
                          borderRadius: 5,
                          padding: "5px",
                          marginBottom: "5px",
                        }}
                      >
                        <CloseIcon />
                      </IconButton>
                    </Tooltip>
                  </MDBox>
                </MDBox>

                <hr />

                <MDBox pb={3} px={1} overflow="auto" height="500px">
                  <MDBox pt={1} px={1}>
                    <MDBox
                      component="form"
                      role="form"
                      onSubmit={formik.handleSubmit}
                    >
                      <Grid container spacing={4}>
                        <Grid item xs={12} lg={4}>
                          <MDBox mb={3} mt={2}>
                            <MDTypography
                              variant="h6"
                              fontWeight="medium"
                              flexGrow={1}
                              style={{ fontWeight: "500", fontSize: 14 }}
                            >
                              Part No/Description
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="partNoDes"
                              fullWidth
                              autoComplete="off"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.partNoDes}
                              error={
                                formik.touched.partNoDes &&
                                formik.errors.partNoDes &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "13px",
                                },
                                readOnly: true,
                                maxLength: 45,
                              }}
                            />
                            {formik.touched.partNoDes &&
                              formik.errors.partNoDes && (
                                <TextError
                                  style={{ marginBottom: "-10px" }}
                                  msg={formik.errors.partNoDes}
                                />
                              )}
                          </MDBox>

                          <MDBox mb={3} mt={2}>
                            <MDTypography
                              variant="h6"
                              fontWeight="medium"
                              flexGrow={1}
                              style={{ fontWeight: "500", fontSize: 14 }}
                            >
                              Po No/Line Number{" "}
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="poNoLineNo"
                              fullWidth
                              autoComplete="off"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.poNoLineNo}
                              error={
                                formik.touched.poNoLineNo &&
                                formik.errors.poNoLineNo &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "14px",
                                },
                                readOnly: true,

                                maxLength: 45,
                              }}
                            />
                            {formik.touched.poNoLineNo &&
                              formik.errors.poNoLineNo && (
                                <TextError msg={formik.errors.poNoLineNo} />
                              )}
                          </MDBox>
                          <MDBox mb={3} mt={2}>
                            <MDTypography
                              variant="h6"
                              fontWeight="medium"
                              flexGrow={1}
                              style={{ fontWeight: "500", fontSize: 14 }}
                            >
                              Type of Packet{" "}
                            </MDTypography>

                            <MDInput
                              type="text"
                              name="packageType"
                              fullWidth
                              autoComplete="off"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={singleAsnPackageTypeData}
                              error={
                                formik.touched.packageType &&
                                formik.errors.packageType &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "13px",
                                },
                                readOnly: true,

                                maxLength: 45,
                              }}
                            />
                            {formik.touched.packageType &&
                              formik.errors.packageType && (
                                <TextError msg={formik.errors.packageType} />
                              )}
                          </MDBox>
                          <MDBox mb={3} mt={2}>
                            <MDTypography
                              variant="h6"
                              fontWeight="medium"
                              flexGrow={1}
                              style={{ fontWeight: "500", fontSize: 14 }}
                            >
                              Unloading Point{" "}
                            </MDTypography>

                            <MDInput
                              type="text"
                              name="unloadingPoint"
                              fullWidth
                              autoComplete="off"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={singleUnloadingPointData}
                              error={
                                formik.touched.unloadingPoint &&
                                formik.errors.unloadingPoint &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "13px",
                                },
                                readOnly: true,

                                maxLength: 45,
                              }}
                            />

                            {formik.touched.unloadingPoint &&
                              formik.errors.unloadingPoint && (
                                <TextError msg={formik.errors.unloadingPoint} />
                              )}
                          </MDBox>
                          <MDBox mb={3} mt={2}>
                            <MDTypography
                              variant="h6"
                              fontWeight="medium"
                              flexGrow={1}
                              style={{ fontWeight: "500", fontSize: 14 }}
                            >
                              Delivery Plant{" "}
                            </MDTypography>

                            <MDInput
                              type="text"
                              name="deliveryPlant"
                              fullWidth
                              autoComplete="off"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={singleDeliveryPlantData}
                              error={
                                formik.touched.deliveryPlant &&
                                formik.errors.deliveryPlant &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "14px",
                                  marginTop: "1px",
                                },
                                readOnly: true,

                                maxLength: 45,
                              }}
                            />

                            {formik.touched.deliveryPlant &&
                              formik.errors.deliveryPlant && (
                                <TextError msg={formik.errors.deliveryPlant} />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={4}>
                          <MDBox mb={3} mt={2}>
                            <MDTypography
                              variant="h6"
                              fontWeight="medium"
                              flexGrow={1}
                              style={{ fontWeight: "500", fontSize: 14 }}
                            >
                              Schedule Quantity{" "}
                            </MDTypography>
                            <MDInput
                              type="number"
                              name="scheduleQuantity"
                              fullWidth
                              autoComplete="off"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.scheduleQuantity}
                              error={
                                formik.touched.scheduleQuantity &&
                                formik.errors.scheduleQuantity &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "13px",
                                },
                                readOnly: true,

                                maxLength: 45,
                              }}
                            />
                            {formik.touched.scheduleQuantity &&
                              formik.errors.scheduleQuantity && (
                                <TextError
                                  msg={formik.errors.scheduleQuantity}
                                />
                              )}
                          </MDBox>
                          <MDBox mb={3} mt={2}>
                            <MDTypography
                              variant="h6"
                              fontWeight="medium"
                              flexGrow={1}
                              style={{ fontWeight: "500", fontSize: 14 }}
                            >
                              Balance Quantity
                            </MDTypography>
                            <MDInput
                              type="number"
                              name="balanceQty"
                              fullWidth
                              autoComplete="off"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={singleASNData.balanceQty - asnQtyChange}
                              error={
                                formik.touched.balanceQty &&
                                formik.errors.balanceQty &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "13px",
                                },
                                readOnly: true,
                                inputProps: {
                                  max: singleASNData.balanceQty,
                                  min: 1,
                                },
                              }}
                            />
                            {formik.touched.balanceQty &&
                              formik.errors.balanceQty && (
                                <TextError msg={formik.errors.balanceQty} />
                              )}
                          </MDBox>
                          <MDBox mb={3} mt={2}>
                            <MDTypography
                              variant="h6"
                              fontWeight="medium"
                              flexGrow={1}
                              style={{ fontWeight: "500", fontSize: 14 }}
                            >
                              ASN Quantity{" "}
                              <Tooltip title="Required" placement="right">
                                <span
                                  style={{
                                    color: "red",
                                    marginLeft: 5,
                                    marginBottom: 15,
                                  }}
                                >
                                  *
                                </span>
                              </Tooltip>
                            </MDTypography>
                            <MDInput
                              type="number"
                              name="asnQty"
                              fullWidth
                              autoComplete="off"
                              onChange={(e) => {
                                setAsnQtyChange(e.target.value);
                                calculatePacketDetails(
                                  e.target.value,
                                  partCode,
                                  email,
                                  jwtToken,
                                );
                              }}
                              onBlur={formik.handleBlur}
                              value={formik.values.asnQty}
                              error={
                                formik.touched.asnQty &&
                                formik.errors.asnQty &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "13px",
                                },
                              }}
                            />
                            {formik.touched.asnQty && formik.errors.asnQty && (
                              <MDBox mb={-3}>
                                <TextError msg={formik.errors.asnQty} />
                              </MDBox>
                            )}
                          </MDBox>

                          <MDBox mb={3} mt={2}>
                            <MDTypography
                              variant="h6"
                              fontWeight="medium"
                              flexGrow={1}
                              style={{ fontWeight: "500", fontSize: 14 }}
                            >
                              No of Packet/Bin{" "}
                            </MDTypography>
                            <MDInput
                              type="number"
                              name="packetNo"
                              fullWidth
                              autoComplete="off"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={singleAsnPackageDetailsData.packetQty}
                              error={
                                formik.touched.packetNo &&
                                formik.errors.packetNo &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "13px",
                                },
                                readOnly: true,
                              }}
                            />
                            {formik.touched.packetNo &&
                              formik.errors.packetNo && (
                                <TextError msg={formik.errors.packetNo} />
                              )}
                          </MDBox>
                          <MDBox mb={3} mt={2}>
                            <MDTypography
                              variant="h6"
                              fontWeight="medium"
                              flexGrow={1}
                              style={{ fontWeight: "500", fontSize: 14 }}
                            >
                              Unit Pack Quantity{" "}
                            </MDTypography>
                            <MDInput
                              type="number"
                              name="unitPackQuantity"
                              fullWidth
                              autoComplete="off"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={singleAsnPackageDetailsData.unitPackQty}
                              error={
                                formik.touched.unitPackQuantity &&
                                formik.errors.unitPackQuantity &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "14px",
                                  marginTop: "2px",
                                },
                                readOnly: true,
                              }}
                            />
                            {formik.touched.unitPackQuantity &&
                              formik.errors.unitPackQuantity && (
                                <TextError
                                  msg={formik.errors.unitPackQuantity}
                                />
                              )}
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={4}>
                          <MDBox mb={3} mt={2}>
                            <MDTypography
                              variant="h6"
                              fontWeight="medium"
                              flexGrow={1}
                              style={{ fontWeight: "500", fontSize: 14 }}
                            >
                              Unit Packet Weight (kg)
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="packetWeight"
                              fullWidth
                              autoComplete="off"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={singleAsnPackageWeightData}
                              error={
                                formik.touched.packetWeight &&
                                formik.errors.packetWeight &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "13px",
                                },
                                readOnly: true,

                                maxLength: 45,
                              }}
                            />
                            {formik.touched.packetWeight &&
                              formik.errors.packetWeight && (
                                <TextError msg={formik.errors.packetWeight} />
                              )}
                          </MDBox>
                          <MDBox mb={3} mt={2}>
                            <MDTypography
                              variant="h6"
                              fontWeight="medium"
                              flexGrow={1}
                              style={{ fontWeight: "500", fontSize: 14 }}
                            >
                              Invoice No{" "}
                              <Tooltip title="Required" placement="right">
                                <span
                                  style={{
                                    color: "red",
                                    marginLeft: 5,
                                    marginBottom: 15,
                                  }}
                                >
                                  *
                                </span>
                              </Tooltip>
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="invoiceNo"
                              fullWidth
                              autoComplete="off"
                              onChange={(e) => {
                                setInvoiceNo(e.target.value);
                              }}
                              onBlur={formik.handleBlur}
                              value={invoiceNo}
                              error={
                                formik.touched.invoiceNo &&
                                formik.errors.invoiceNo &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "12px",
                                },

                                maxLength: 45,
                              }}
                            />
                            {formik.touched.invoiceNo &&
                              formik.errors.invoiceNo && (
                                <MDBox mb={-3}>
                                  <TextError msg={formik.errors.invoiceNo} />
                                </MDBox>
                              )}
                          </MDBox>

                          <MDBox mb={3} mt={2}>
                            <MDTypography
                              variant="h6"
                              fontWeight="medium"
                              flexGrow={1}
                              style={{
                                fontWeight: "500",
                                fontSize: 14,
                                // marginBottom: "2px",
                              }}
                            >
                              Invoice Date{" "}
                              <Tooltip title="Required" placement="right">
                                <span
                                  style={{
                                    color: "red",
                                    marginLeft: 5,
                                    // marginBottom: 5,
                                  }}
                                >
                                  *
                                </span>
                              </Tooltip>
                            </MDTypography>

                            <MDInput
                              type="date"
                              name="invoiceDate"
                              onKeyDown={(e) => e.preventDefault()}
                              fullWidth
                              autoComplete="off"
                              onChange={(e) => {
                                setInvoiceDate(e.target.value);
                              }}
                              onBlur={formik.handleBlur}
                              value={invoiceDate}
                              error={
                                formik.touched.invoiceDate &&
                                formik.errors.invoiceDate &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "12.5px",
                                },

                                max: currentDate,
                              }}
                            />

                            {formik.touched.invoiceDate &&
                              formik.errors.invoiceDate && (
                                <MDBox mb={-3}>
                                  <TextError msg={formik.errors.invoiceDate} />
                                </MDBox>
                              )}
                          </MDBox>

                          <MDBox mb={3} mt={2}>
                            <MDTypography
                              variant="h6"
                              fontWeight="medium"
                              flexGrow={1}
                              style={{ fontWeight: "500", fontSize: 14 }}
                            >
                              Invoice (PDF Only)
                              <Tooltip title="Required" placement="right">
                                <span
                                  style={{
                                    color: "red",
                                    marginLeft: 5,
                                    // marginBottom: 15,
                                  }}
                                >
                                  *
                                </span>
                              </Tooltip>
                            </MDTypography>
                            <input
                              name="invoiceFile"
                              style={{
                                borders: "none",
                                marginTop: "0px",
                                width: "100%",
                              }}
                              className="choose_file"
                              type="file"
                              autoComplete="off"
                              accept=".pdf"
                              id="chooseFile"
                              onChange={(event) =>
                                handleChangeForInvoiceFile(event)
                              }
                            />
                          </MDBox>

                          <MDBox mb={3} mt={2}>
                            <MDTypography
                              variant="h6"
                              fontWeight="medium"
                              flexGrow={1}
                              style={{ fontWeight: "500", fontSize: 14 }}
                            >
                              Test Certificate (PDF Only)
                              <span
                                style={{
                                  color: "red",
                                  marginLeft: 5,
                                  // marginBottom: 15,
                                }}
                              >
                                *
                              </span>
                            </MDTypography>
                            <input
                              name="testCertificate"
                              style={{
                                borders: "none",
                                marginTop: "0px",
                                width: "100%",
                                // height:"15px"
                              }}
                              className="choose_file"
                              type="file"
                              autoComplete="off"
                              accept=".pdf"
                              id="chooseFile"
                              onChange={(event) =>
                                handleChangeForTestCertificate(event)
                              }
                            />
                          </MDBox>
                        </Grid>
                      </Grid>

                      <MDBox>
                        <Collapse in={isErrorCreateASN}>
                          <Alert
                            severity="error"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsErrorCreateASN(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            {createAsnError}
                          </Alert>
                        </Collapse>
                        <Collapse in={isSuccessCreateASN}>
                          <Alert
                            severity="success"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsSuccessCreateASN(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            ASN created successfully
                          </Alert>
                        </Collapse>
                      </MDBox>
                      <MDBox mt={2} display="flex">
                        <MDBox mr={2}>
                          <MDButton
                            color="info"
                            type="submit"
                            marginRight="10px"
                            disabled={
                              !formik.isValid ||
                              !fileForInvoiceFile.name ||
                              !fileForTestCertificate.name ||
                              fileForTestCertificate.type !==
                                "application/pdf" ||
                              fileForInvoiceFile.type !== "application/pdf" ||
                              invoiceDate === "" ||
                              invoiceNo === "" ||
                              buttonNameForCreateAsn === "Please wait..."
                            }
                          >
                            {buttonNameForCreateAsn}
                          </MDButton>
                        </MDBox>
                        <MDBox>
                          <MDButton
                            color="success"
                            type="submit"
                            marginLeft="20px"
                            onClick={() => {
                              // setPrintAsnDetailsInvoiceNo(
                              //   formik.values.invoiceDate
                              // );
                              handleOpenPrintASNModal();
                            }}
                            disabled={
                              !(
                                /Can/i.test(packageType) ||
                                /Carton/i.test(packageType) ||
                                /Corrugated/i.test(packageType)
                              )
                            }
                          >
                            Print PKT QTY
                          </MDButton>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>
            <Modal
              open={openUpdateActualQtyModal}
              onClose={handleCloseUpdateActualQtyModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={style}>
                <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                  <MDTypography variant="h4" fontWeight="medium" flexGrow={1}>
                    Update Actual Qty
                  </MDTypography>
                  <MDBox>
                    <Tooltip title="Close">
                      <IconButton
                        aria-label="close"
                        color="inherit"
                        onClick={handleCloseUpdateActualQtyModal}
                        style={{
                          background: "whitesmoke",
                          color: "black",
                          borderRadius: 5,
                          marginLeft: "-55px",
                        }}
                      >
                        <CloseIcon />
                      </IconButton>
                    </Tooltip>
                  </MDBox>
                </MDBox>
                <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                <MDBox pt={1} pb={3} px={3}>
                  <MDBox
                    component="form"
                    role="form"
                    onSubmit={formikForUpdate.handleSubmit}
                  >
                    <MDBox mb={2}>
                      <MDTypography variant="h6">Actual Qty</MDTypography>
                      <MDInput
                        type="number"
                        name="actualQty"
                        fullWidth
                        autoComplete="off"
                        inputProps={{
                          maxLength: 45,
                        }}
                        onBlur={formikForUpdate.handleBlur}
                        onChange={formikForUpdate.handleChange}
                        value={formikForUpdate.values.actualQty}
                        error={
                          formikForUpdate.touched.actualQty &&
                          formikForUpdate.errors.actualQty &&
                          true
                        }
                      />
                      {formikForUpdate.touched.actualQty &&
                        formikForUpdate.errors.actualQty && (
                          <TextError msg={formikForUpdate.errors.actualQty} />
                        )}
                    </MDBox>

                    <MDBox>
                      <Collapse in={isErrorForUpdate}>
                        <Alert
                          severity="error"
                          action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                setIsErrorForUpdate(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        >
                          {errorMsgForUpdateQty}
                        </Alert>
                      </Collapse>
                      <Collapse in={isSuccessForUpdate}>
                        <Alert
                          severity="success"
                          action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                setIsErrorForUpdate(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        >
                          Actual Qty updated successfully
                        </Alert>
                      </Collapse>
                    </MDBox>
                    <MDBox mt={3}>
                      <MDButton
                        variant="contained"
                        color="success"
                        fullWidth
                        type="submit"
                        disabled={
                          !formikForUpdate.isValid ||
                          buttonName === "Please wait..."
                        }
                      >
                        {buttonName}
                      </MDButton>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>
            <Modal
              open={openPrintASNModal}
              onClose={handleClosePrintASNModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={styleForDocumentPrint}>
                <MDBox ml={1} mt={-1} display="flex" alignItems="center">
                  <MDTypography variant="h4" fontWeight="medium" flexGrow={1}>
                    Print
                  </MDTypography>
                  <MDBox>
                    <Tooltip title="Close">
                      <IconButton
                        aria-label="close"
                        color="inherit"
                        onClick={handleClosePrintASNModal}
                        style={{
                          background: "whitesmoke",
                          color: "black",
                          borderRadius: 5,
                          marginLeft: "-55px",
                        }}
                      >
                        <CloseIcon />
                      </IconButton>
                    </Tooltip>
                  </MDBox>
                </MDBox>
                <MDBox>
                  <MDBox pt={1} pb={3} height="100%">
                    <div ref={componentRef}>
                      {printData.map((person) => {
                        return (
                          <Document>
                            <Page size="A4" style={styles.page}>
                              <View
                                style={{
                                  marginBottom: "20px",
                                  marginRight: "0px",
                                  marginTop: "50px",
                                  marginLeft: "20px",
                                }}
                              >
                                <table
                                  style={{
                                    width: "100%",
                                    marginBottom: "-110px",
                                  }}
                                >
                                  <thead
                                    style={{
                                      borderSpacing: "5px",
                                      border: "1px solid grey",
                                    }}
                                  >
                                    <tr style={{ padding: "10px" }}>
                                      <th style={{ padding: "10px" }}>
                                        ASN Code
                                      </th>
                                      <th style={{ padding: "10px" }}>
                                        Part Code
                                      </th>
                                      <th style={{ padding: "10px" }}>
                                        Part Description
                                      </th>
                                      <th style={{ padding: "10px" }}>
                                        Bin Code
                                      </th>

                                      <th style={{ padding: "20px" }}>QTY</th>
                                      <th style={{ padding: "20px" }}>
                                        QR Code
                                      </th>
                                    </tr>
                                  </thead>
                                  <hr style={{ width: "670%" }} />
                                  <tbody
                                    style={{
                                      height: "60%",
                                    }}
                                  >
                                    <tr
                                      style={{
                                        padding: "10px",
                                        border: "1px solid grey",
                                      }}
                                    >
                                      <td style={{ padding: "10px" }}>
                                        {person.asnCode}
                                      </td>
                                      <td style={{ padding: "10px" }}>
                                        {person.itemCode}
                                      </td>
                                      <td style={{ padding: "10px" }}>
                                        {person.itemDescription}
                                      </td>
                                      <td style={{ padding: "10px" }}>
                                        {person.binCode}
                                      </td>
                                      <td style={{ padding: "20px" }}>
                                        {person.qty}
                                      </td>
                                      <td
                                        style={{
                                          padding: "20px",
                                          marginLeft: "50px",
                                        }}
                                      >
                                        <QRCode
                                          size={30}
                                          style={{
                                            height: "auto",
                                            maxWidth: "100%",
                                            width: "100%",
                                          }}
                                          value={person.binCode}
                                          viewBox={`0 0 156 156`}
                                        />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </View>
                            </Page>
                          </Document>
                        );
                      })}
                    </div>

                    <MDButton
                      color="success"
                      type="button"
                      onClick={handlePrint}
                      style={{ marginLeft: "10px" }}
                    >
                      Print
                    </MDButton>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>
            <Modal
              open={openCreatePickupListModal}
              onClose={handleCloseCreatePickupListModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={style}>
                <MDTypography>
                  Are you sure you want to create pickup list?
                </MDTypography>
                <MDBox mt={2}>
                  <MDButton
                    style={{ width: "48%", marginRight: "0.5rem" }}
                    color="info"
                    variant="outlined"
                    onClick={handleCloseCreatePickupListModal}
                  >
                    Cancel
                  </MDButton>
                  <MDButton
                    style={{ width: "48%", marginLeft: "0.5rem" }}
                    color="info"
                    onClick={onClickCreatePickupList}
                  >
                    Create
                  </MDButton>
                </MDBox>
                <MDBox mt={2}>
                  <Collapse in={isErrorCreatePickupList}>
                    <Alert
                      severity="error"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsErrorCreatePickupList(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      {/* Could not Create the Pickup List */}
                    </Alert>
                  </Collapse>
                </MDBox>
              </MDCard>
            </Modal>
          </Card>
        </Grid>
      </Grid>
      {(uploadLoader || loading) && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <MDSnackbar
        color="error"
        icon="notifications"
        title="Alert"
        content="Please Go To Monthly Demand And Confirm Actual Qty"
        open={show}
        vertical="top"
        horizontal="center"
        close={toggleSnackbar}
      />
      <ToastContainer />
    </MDBox>
  );
};

const mapStateToProps = (state) => {
  return {
    dailyDemandReducer: state.dailyDemandReducer,
    dailyDemandForDownloadReducer: state.dailyDemandForDownloadReducer,
    partNoForPlannerReducer: state.partNoForPlannerReducer,
    partNoReducer: state.partNoReducer,
    plantReducer: state.plantReducer,
    vendorsListForPlannerReducer: state.vendorsListForPlannerReducer,
    packageTypeReducer: state.packageTypeReducer,
    packageDetailsReducer: state.packageDetailsReducer,
    deliveryPlantReducer: state.deliveryPlantReducer,
    unloadingPointReducer: state.unloadingPointReducer,
    packetWeightReducer: state.packetWeightReducer,
    binsForPrintReducer: state.binsForPrintReducer,
    unConfirmedMonthlyDemandReducer: state.unConfirmedMonthlyDemandReducer,
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    getPurchaseOrdersForDemandReducer: state.getPurchaseOrdersForDemandReducer,

    getDynamicColumnReducer: state.getDynamicColumnReducer,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    getDailyDemand: (
      userId,
      partNo,
      plant,
      vendorCode,
      roleName,
      startDate,
      endDate,
      purchaseOrderNumber,
      pageNo,
      rowsPerPage,
      searchObject,
      jwtToken,
    ) =>
      dispatch(
        getDailyDemand(
          userId,
          partNo,
          plant,
          vendorCode,
          roleName,
          startDate,
          endDate,
          purchaseOrderNumber,
          pageNo,
          rowsPerPage,
          searchObject,
          jwtToken,
        ),
      ),

    getDailyDemandForDownload: (
      userId,
      partNo,
      plant,
      vendorCode,
      roleName,
      startDate,
      endDate,
      pageNo,
      rowsPerPage,
      searchObject,
      jwtToken,
    ) =>
      dispatch(
        getDailyDemandForDownload(
          userId,
          partNo,
          plant,
          vendorCode,
          roleName,
          startDate,
          endDate,
          pageNo,
          rowsPerPage,
          searchObject,
          jwtToken,
        ),
      ),
    uploadCsvForDailyDemand: (payload, jwtToken) =>
      dispatch(uploadCsvForDailyDemand(payload, jwtToken)),
    getBinsForPrint: (asnCode, jwtToken) =>
      dispatch(getBinsForPrint(asnCode, jwtToken)),
    getPartNoForPlanner: (jwtToken) => dispatch(getPartNoForPlanner(jwtToken)),
    getPartNo: (userId, jwtToken) => dispatch(getPartNo(userId, jwtToken)),
    getPlant: (jwtToken) => dispatch(getPlant(jwtToken)),
    getVendorsListForPlanner: (jwtToken) =>
      dispatch(getVendorsListForPlanner(jwtToken)),
    getPackageType: (partCode, jwtToken) =>
      dispatch(getPackageType(partCode, jwtToken)),
    calculatePacketWeight: (partCode, asnQtyChange, jwtToken) =>
      dispatch(calculatePacketWeight(partCode, asnQtyChange, jwtToken)),
    getUnloadingPoint: (id, jwtToken) =>
      dispatch(getUnloadingPoint(id, jwtToken)),
    getDeliveryPlant: (id, jwtToken) =>
      dispatch(getDeliveryPlant(id, jwtToken)),
    createAsn: (payload, jwtToken) => dispatch(createAsn(payload, jwtToken)),
    calculatePacketDetails: (asnQty, partCode, userId, jwtToken) =>
      dispatch(calculatePacketDetails(asnQty, partCode, userId, jwtToken)),
    getUnConfirmedMonthlyDemand: (userId, jwtToken) =>
      dispatch(getUnConfirmedMonthlyDemand(userId, jwtToken)),
    updateActualQty: (payload, jwtToken) =>
      dispatch(updateActualQty(payload, jwtToken)),
    getPurchaseOrdersForDemand: (id, jwtToken) =>
      dispatch(getPurchaseOrdersForDemand(id, jwtToken)),

    getDynamicColumn: (userId, subModuleId, jwtToken) =>
      dispatch(getDynamicColumn(userId, subModuleId, jwtToken)),
    createDynamicColumn: (payload, jwtToken) =>
      dispatch(createDynamicColumn(payload, jwtToken)),
  };
};

export default connect(mapStateToProps, mapStateToDispatch)(DailyDemand);
